import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useTheme } from '../../context/ThemeContext';

const SSOLoginButton = ({ teamId, onLoading }) => {
  const [loading, setLoading] = useState(false);
  const { darkMode } = useTheme();

  const handleSSOLogin = async () => {
    if (!teamId) {
      toast.error('Please enter your team ID first');
      return;
    }

    setLoading(true);
    if (onLoading) onLoading(true);

    try {
      const response = await axios.get(`/api/sso/o365/login?teamId=${teamId}`);
      
      if (response.data.success && response.data.authUrl) {
        // Redirect to Office365 authentication
        window.location.href = response.data.authUrl;
      } else {
        toast.error('Failed to initiate SSO login');
      }
    } catch (error) {
      console.error('SSO login error:', error);
      toast.error(error.response?.data?.message || 'SSO login failed');
    } finally {
      setLoading(false);
      if (onLoading) onLoading(false);
    }
  };

  return (
    <button
      onClick={handleSSOLogin}
      disabled={loading || !teamId}
      className="w-full flex items-center justify-center transition-opacity duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? (
        <div className="flex items-center justify-center px-4 py-3 bg-gray-600 text-white rounded-lg w-full">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Connecting...
        </div>
      ) : (
        <img 
          src={darkMode ? '/images/ms-signin-dark.svg' : '/images/ms-signin-light.svg'}
          alt="Sign in with Microsoft"
          className="w-full max-w-[215px] h-[41px]"
        />
      )}
    </button>
  );
};

export default SSOLoginButton;
